import { HashRouter, Routes, Route } from 'react-router-dom';
import Layout from '@/components/Layout';
import HomePage from '@/pages/HomePage';
import ProcedurePage from '@/pages/ProcedurePage';

export default function App() {
  return (
    <HashRouter>
      <Layout>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/procedure/:id" element={<ProcedurePage />} />
        </Routes>
      </Layout>
    </HashRouter>
  );
}
